(ns ui.view.card.associated-entities.model)

(def table-states-path [:table-states])

(defn table-state-path
  [table-index]
  (conj table-states-path table-index))

(def table-group-by-association-type-path [:group-by-association-type?])

(defn table-group-by-association-type-full-path
  [card-state-path table-index]
  (into card-state-path [:table-states table-index :group-by-association-type?]))

(def table-expanded-path [:expanded?])

(defn table-expanded-full-path
  [card-state-path table-index]
  (into card-state-path [:table-states table-index :expanded?]))

(def table-row-group-expanded-states-path [:row-group-expanded])

(defn table-row-group-expanded-full-path
  [card-state-path table-index group-key]
  (into card-state-path [:table-states table-index :row-group-expanded group-key]))

(defn table-sort-model-full-path
  [card-state-path table-index]
  (into card-state-path [:table-states table-index :sort-model]))
